export const UI_MODAL_OPEN = 'UI_MODAL_OPEN';
export const UI_MODAL_CLOSE = 'UI_MODAL_CLOSE';
export const UI_SET_BREADCRUMBS = 'UI_SET_BREADCRUMBS';
export const UI_SET_MENU_TAXON = 'UI_SET_MENU_TAXON';

const initialState = {
  modal: {},
  menuTaxon: process.env.PRIMARY_TAXON,
  breadcrumbs: []
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case UI_MODAL_OPEN:
      return {
        ...state,
        modal: payload
      };
    case UI_MODAL_CLOSE:
      return {
        ...state,
        modal: {}
      };
    case UI_SET_MENU_TAXON:
      return {
        ...state,
        menuTaxon: payload
      };
    case UI_SET_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: payload
      };
    default:
      return state;
  }
}

export function openModal(ModalComponent, data = null) {
  return {type: UI_MODAL_OPEN, payload: {name: ModalComponent.modalName, data}};
}

export function closeModal() {
  return {type: UI_MODAL_CLOSE};
}

export function setUiMenuTaxon(taxonCode) {
  return {type: UI_SET_MENU_TAXON, payload: taxonCode};
}

export function setUiBreadcrumbs(breadcrumbs) {
  return {type: UI_SET_BREADCRUMBS, payload: breadcrumbs};
}



// WEBPACK FOOTER //
// ./ducks/ui.js